import { render, staticRenderFns } from "./menu-conversations.vue?vue&type=template&id=63be7a49&scoped=true&"
import script from "./menu-conversations.vue?vue&type=script&lang=js&"
export * from "./menu-conversations.vue?vue&type=script&lang=js&"
import style0 from "./menu-conversations.vue?vue&type=style&index=0&id=63be7a49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63be7a49",
  null
  
)

export default component.exports